/* eslint-disable no-undef,no-unused-vars */

// import _merge from lodash
const _merge = require('lodash.merge')

export const state = () => ({
  // admin view
  admin_view: false,

  // external API endpoints
  core_api_endpoint: process.env.CORE_URL,

  // respondent instructions
  respondent: {
    entity_uuid: null,
    instructions: null,
  },

  // these could be moved to i18n layer: https://github.com/logaretm/vee-validate/issues/2104#issuecomment-497905356
  validation: {
    messages: {
      en: {
        required: 'This field is required',
        numeric: 'A numeric value is required',
        alpha_dash:
          'Alphanumeric characters, dashes, and underscores only (no spaces or special characters)',
        email: 'Please enter a valid email address',
        requiredCheckboxes: 'At least one checkbox is required',
      },
      es: {
        required: 'Este campo es obligatorio',
        numeric: 'Se requiere un valor numérico',
        alpha_dash:
          'Caracteres alfanuméricos, guiones y guiones bajos solamente (sin espacios ni caracteres especiales)',
        email:
          'Por favor, introduzca una dirección de correo electrónico válida',
        requiredCheckboxes: 'Se requiere al menos una casilla de verificación',
      },
    },
  },

  // errors container
  errors: {
    couldNotFindRespondent: false,
  },

  // loading status
  loading: false,
})

// computed properties
export const getters = {
  core_api_endpoint(state) {
    return state.core_api_endpoint
  },
  errors(state) {
    return state.errors
  },
}

// Mutations are never async
export const mutations = {
  updateInputJSON(state, { path, payload }) {
    state.current_api_path = path
    state.json_editors.input_editor.content = payload
  },

  updateOutputJSON(state, jsonUpdate) {
    state.json_editors.output_editor.content = jsonUpdate
  },

  resetOutputJSON(state) {
    state.json_editors.output_editor.content = {
      msg: 'input changed, waiting for button to be pressed...',
    }
  },

  updateInstructions(state, instructions) {
    console.log('ACTION: updating the instructions currently stored in state')
    state.respondent.instructions = instructions
  },

  updateEntityUUID(state, entityUUID) {
    console.log('ACTION: updating entity_uuid via dynamic route')
    state.respondent.entity_uuid = entityUUID
  },

  updateAdminView(state, updateValue) {
    console.log('MUTATION: updating admin_view')
    state.admin_view = updateValue
  },

  clearInstructions(state) {
    state.respondent.instructions = null
  },

  updateErrors(state, update) {
    _merge(state.errors, update)
  },

  setLoading(state, value) {
    state.loading = value
  },
}

// Actions can optionally be async
export const actions = {
  updateEntityUUID: ({ commit, state }, entityUUID) => {
    // submit mutation
    commit('updateEntityUUID', entityUUID)
  },

  updateInputJSON: ({ commit, state }, { path, payload }) => {
    // update input state
    commit('updateInputJSON', { path, payload })

    // update output state
    commit('resetOutputJSON')
  },

  async submitAPIQuery({ commit, state, rootState }) {
    // submit query to service.surveys
    const response = await this.$axios.$post(
      `${state.api_endpoint_base}${state.current_api_path}`,
      state.json_editors.input_editor.content
    )

    // update output
    commit('updateOutputJSON', response)
  },

  async submitResponse({ commit, state, dispatch, getters }, responseObj) {
    /*
    Async method to submit instructions
    */

    // submit response
    try {
      const response = await this.$axios.post(
        `${getters.core_api_endpoint}/smart-surveys/me/responses`,
        [responseObj]
      )
      dispatch(
        'updateInstructions',
        response.data.results.entities[state.respondent.entity_uuid]
          .updated_instructions
      )
    } catch (error) {
      // If the server returns error 500, it implies that the response was saved,
      // but encountered an error creating instructions for the response.
      // In this case, the client should issue a new api call to refresh its
      // instructions.
      if (error.response?.status === 500 || error.message === 'Network Error') {
        dispatch('generateInstructions')
      }
      // throw error so the caller can handle it
      throw error
    }
  },

  async generateInstructions({ commit, state, rootState, dispatch, getters }) {
    /*
    Method to retrieve instructions for a respondent and update store
     */

    commit('setLoading', true)
    // whenever generating instructions, clear instructions first
    commit('clearInstructions')

    // query smart surveys endpoints for instructions with entity_uuid in hand
    try {
      const instructions = await this.$axios.$get(
        `${getters.core_api_endpoint}/smart-surveys/me/instructions`
      )
      // update entity uuid
      commit('updateEntityUUID', instructions.respondent.code)
      // update instructions
      dispatch('updateInstructions', instructions)
    } catch (error) {
      console.error(error.response)
      if (error.response?.status === 404) {
        commit('updateErrors', { couldNotFindRespondent: true })
      }
    } finally {
      commit('setLoading', false)
    }
  },

  updateInstructions({ commit, state }, instructions) {
    /*
    Action to update instructions
      - store raw instructions to store
      - for each group, localize questions
     */

    console.log('ACTION: updateInstructions')

    // mutate instructions
    commit('updateInstructions', instructions)
  },

  clearInstructions({ commit, state }) {
    console.log('ACTION: clearInstructions')
    commit('clearInstructions')
  },
}
